import { render } from "./UpsOvi.vue?vue&type=template&id=9d651562&scoped=true"
import script from "./UpsOvi.vue?vue&type=script&lang=js"
export * from "./UpsOvi.vue?vue&type=script&lang=js"

import "./UpsOvi.vue?vue&type=style&index=0&id=9d651562&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d651562"]])

export default __exports__